/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mainAuthInclude.vue?vue&type=template&id=6bdd7b82"
import script from "./mainAuthInclude.vue?vue&type=script&lang=js"
export * from "./mainAuthInclude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports